import { regex } from '@/utils/regex'
import { dataDeal } from '@/utils/data'
/**
 * 过滤器
 * 全局过滤器定义
 */

export const mobile = (value) => {
  return (value && value.replace(regex.mobileSecret, '$1****$2')) || value
}
export function Currency (value) {
  value = (+value || 0).toFixed(2)
  return `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}

export const percent = (value) => {
  return (!isNaN(value) && `${value}%`) || ''
}

export const arrivalStatus = (value) => {
  value = value === 'x1' ? 1 : (+value === 0 ? 0 : (+value < 0) ? 2 : 3)
  return ['已到账', '未到账', '部分到账', '超额到账'][value]
}

export const refundStatus = (value) => {
  value = value === 'x1' ? 1 : (+value === 0 ? 0 : (+value < 0) ? 2 : 3)
  return ['已回款', '未回款', '部分回款', '超额回款'][+value]
}

export const customerStatus = (value) => {
  value = +value === -1 ? 0 : +value
  return ['禁用', '未实名', '已实名', '已签约', '实名不通过', '实名审核中', '实名信息不一致'][value]
}

export const invoiceStatus = (value) => {
  value = +value === -1 ? 0 : +value
  return ['删除', '未申请', '已申请', '已开票', '已邮寄'][value]
}

export const payeeType = (value) => {
  return ['', '业务员', '居间人'][+value]
}

export const payeeStatus = (value) => {
  return ['', '未确认', '已确认'][+value]
}

export const dataStatus = (value) => {
  return ['', '未上传', '已上传'][+value]
}

export const validStatus = (value) => {
  return ['', '启用', '禁用'][+value]
}
export const partnerType = (value) => {
  return ['', '保司', '代理', '公估', '经纪'][value]
}
export const invoiceBatchStatus = (value) => {
  value = +value === -1 ? 0 : +value
  return ['删除', '已申请', '已开票', '已邮寄'][value]
}
export const userType = (value) => {
  return ['', '个人用户', '代理机构', '会员用户', '管理员'][value]
}
export const authType = (value) => {
  return ['', '', '--编辑', '--助理'][value]
}
export const companyType = (value) => {
  return ['个体', '个体工商户', '股份合作制', '股份有限公司', '股份有限公司国有企业', '股份有限公司国有企业', '股份有限公司分公司(非上市、自然人投资或控股)', '股份制', '股份制分支机构', '股份制企业(非法人)', '国有经营单位(非法人)', '国有企业', '集体所有制', '其他有限责任公司', '有限合伙', '有限责任公司', '有限责任公司港、澳、台', '有限责任公司国有企业', '有限责任公司外商投资企业', '有限责任公司(自然人独资)', '有限责任公司(自然人投资或控股)', '有限责任公司(自然人投资或控股的法人独资)', '有限合伙企业', '有限责任公司私营企业', '有限责任公司外商投资企业港、澳、台', '有限责任公司(法人独资)', '有限责任公司(非自然人投资或控股的法人独资)', '有限责任公司(台港澳与境内合资)', '有限责任公司分公司', '有限责任公司分公司(法人独资)', '有限责任公司分公司(非自然人投资或控股的法人独资)', '有限责任公司分公司(国有独资)', '有限责任公司分公司(国有控股)', '有限责任公司分公司(外商投资企业合资)', '有限责任公司分公司(外商投资企业与内资合资)', '有限责任公司分公司(自然人独资)', '有限责任公司分公司(自然人投资或控股)', '有限责任公司分公司(自然人投资或控股的法人独资)', '银行', '非公司企业法人分支机构(国有经济)', '非公司外商投资企业分支机构', '分公司', '港、澳、台', '个人独资企业', '个人经营', '个体(内地)', '个体户', '工会法人', '股份合作制分支机构', '股份有限公司港、澳、台', '股份有限公司分公司', '股份有限公司分公司(非上市)', '股份有限公司分公司(上市、国有控股)', '股份有限公司分公司(上市、外商投资企业投资)', '国有经济', '合伙企业', '集体分支机构(非法人)', '集体经济', '集体经营单位(非法人)', '集体企业', '集体社团法人营业', '集体事业单位营业', '集团', '经营单位(非法人)', '联营企业', '内资分公司', '内资公司', '内资企业法人', '内资企业法人分支机构(非法人)', '内资企业集团', '农民专业合作经济组织', '农民专业合作社', '普通合伙', '其他股份有限公司分公司(非上市)', '其他有限责任公司分公司', '事业单位营业', '私营企业', '外国(地区)公司分支机构', '外国(地区)企业常驻代表机构', '外商投资企业', '外商投资企业分支机构', '外商投资企业其他分支机构', '其他'][value]
}
export const management = (value) => {
  return ['', '存续', '吊销', '在业', '注销', '仍注册', '迁出', '已终止营业地点', '开业', '正常', '核准设立', '其他'][value]
}
export const statusType = (value) => {
  let ret = ''
  switch (value) {
    case 1:ret = '待审核'; break
    case 2:ret = '已通过'; break
    case 3:ret = '未通过'; break
    case 4:ret = '已撤回'; break
    case 5:ret = '草稿'; break
    case 9:ret = '删除'; break
  }
  return ret
}
export const businessType = (value) => {
  return dataDeal.getBusinessType(value)
}
export const invoiceType = (value) => {
  return dataDeal.getInvoiceType(value)
}
export const expressCompany = (value) => {
  return dataDeal.expressCompany(value)
}



// WEBPACK FOOTER //
// ./src/filters/index.js